import { auth } from "./firebase";
/*

  AUTH ANONYMOUSLY

*/
//Sign in anonymously on init
export const doSignInAnonymously = () => auth.signInAnonymously();

/*

  AUTH WITH EMAIL AND PASSWORD

*/
export const doCreateUserWithEmailAndPassword = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password);

export const doDeleteAnonymousUser = () => auth.currentUser.delete();

export const doDeleteUser = () => auth.currentUser.delete();

//Updates user status to bool value in sagas/client.js
export const doChangeUserStatus = (uid, payload) => auth.updateUser(uid, { disabled: payload });

export const doSignInWithEmailAndPassword = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

/*

  RESET, UPDATE, SIGN OUT

  */
export const doPasswordReset = email =>
  auth.sendPasswordResetEmail(email).catch(err => {
    return err;
  });

export const doPasswordUpdate = password => auth.userAuth.updatePassword(password);

export const doLogout = () => auth.signOut();

/*

  UTIL

*/
export const getCurrentUser = () => auth.currentUser;

export const onceGetUserByEmail = email => auth.getUserByEmail(email);

//Check if email exists (automatic email validation)
export const doFetchProvidersForEmail = email => auth.fetchProvidersForEmail(email);

// Sign out Password Reset Password Change User auth handler
export const doOnAuthStateChanged = watcher => {
  watcher();
};



// WEBPACK FOOTER //
// ./src/firebase/auth.js